var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useRef, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamationTriangle } from "@fortawesome/pro-regular-svg-icons/faExclamationTriangle";
import { faPen } from "@fortawesome/pro-regular-svg-icons/faPen";
import { IconButton, Input, InputAdornment, Tooltip } from "@mui/material";
import { combineSxProps, commonTooltipProps } from "../../Utils";
export const DeprecatedInlineTextField = (props) => {
    var _a;
    const { validate, onConfirmChange, editIconTooltip } = props, inputProps = __rest(props, ["validate", "onConfirmChange", "editIconTooltip"]);
    const cleanInitialValue = typeof inputProps.value === "string" ? inputProps.value : "";
    const inputRef = useRef();
    const [value, setValue] = useState(cleanInitialValue);
    const [lastValue, setLastValue] = useState(value);
    const errorTooltip = (_a = props.validate) === null || _a === void 0 ? void 0 : _a.call(props, value);
    const handleEditClick = () => {
        var _a;
        (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
    };
    useEffect(() => {
        setValue(cleanInitialValue);
        setLastValue(cleanInitialValue);
    }, [cleanInitialValue]);
    const handleFocus = () => {
        setLastValue(value);
    };
    const handleChange = (e) => {
        setValue(e.currentTarget.value);
        props.onChange && props.onChange(e);
    };
    const handleKeyDown = (e) => {
        var _a;
        if (e.key === "Enter") {
            e.preventDefault();
            (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.blur();
        }
        else if (e.key === "Escape") {
            e.preventDefault();
            e.stopPropagation();
            setValue(lastValue);
            setTimeout(() => { var _a; return (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.blur(); }, 0); //to prevent calling onConfirmChange inside handleBlur in the same event loop
        }
    };
    const handleBlur = () => {
        if (value !== lastValue) {
            if (errorTooltip) {
                setValue(lastValue);
            }
            else {
                onConfirmChange(value);
            }
        }
    };
    return (_jsx(Input, Object.assign({}, inputProps, { inputRef: inputRef, endAdornment: (_jsx(InputAdornment, { position: "end", children: _jsx(Tooltip, Object.assign({}, commonTooltipProps, { title: errorTooltip ? errorTooltip : (editIconTooltip || "Edit"), children: errorTooltip
                    ? _jsx(FontAwesomeIcon, { icon: faExclamationTriangle })
                    : (_jsx(IconButton, { size: "small", color: "primary", sx: editButtonSxProps, onClick: handleEditClick, children: _jsx(FontAwesomeIcon, { icon: faPen }) })) })) })), sx: combineSxProps(inputSxProps, inputProps.sx), value: value, onFocus: handleFocus, onChange: handleChange, onKeyDown: handleKeyDown, error: !!errorTooltip, onBlur: handleBlur })));
};
const inputSxProps = {
    caretColor: (theme) => theme.palette.primary.main,
    "&:not(.Mui-error) .MuiInputAdornment-root": {
        visibility: "hidden"
    },
    "&:not(.Mui-disabled)": {
        "&::before": {
            borderBottom: "none"
        },
        "&:hover::before": {
            borderBottom: (theme) => `2px solid ${theme.palette.primary.light}`
        },
        "&:hover .MuiInputAdornment-root": {
            visibility: "visible"
        }
    },
    "&.Mui-error": {
        caretColor: (theme) => theme.palette.error.main,
        "& svg": {
            color: (theme) => theme.palette.error.main
        }
    }
};
const editButtonSxProps = {
    "&:not([disabled]):not(:hover)": {
        color: "action.active"
    }
};
//# sourceMappingURL=DeprecatedInlineTextField.js.map